import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Action } from 'src/app/shared/models/action';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
})
export class ActionCardComponent {
  @Input() action: Action;
  @Input() mode: 'all' | 'week' | 'finished' | 'asked' | 'assignedToMyTeam' | 'fromMail';
  @Output() emitAnswerToAction = new EventEmitter<Action>();

  public openMail(column): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + column.mailId);
  }

  public answerToAction(column): void {
    this.emitAnswerToAction.emit(column);
  }
}
